import React, { useState } from "react";
import { Drawer, DrawerContent, DrawerItem } from "@progress/kendo-react-layout";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWrench } from "@fortawesome/free-solid-svg-icons";

import General from "../DemoPreview/GridSettings/General";
import Subscriptions from "./Subscriptions";

const CustomItem = ({ customIcon, text = "", ...props }) => {
    return (
        <DrawerItem {...props}>
            <div className="d-flex flex-row align-items-center">
                <FontAwesomeIcon icon={customIcon} className="me-3" />

                {text}
            </div>
        </DrawerItem>
    );
};

const childMap = {
    "/general": (props) => <General {...props} />,
    "/subscriptions": (props) => <Subscriptions {...props} />,
};

const items = [
    {
        text: "General",
        customIcon: faWrench,
        selected: true,
        route: "/general",
    },
];

const AccountSettingsRouter = ({ module, initialSelected, settings, setSettings, setChangeMade }) => {
    const [selected, setSelected] = useState(initialSelected ?? "/general");

    const onSelect = (e) => {
        setSelected(e.itemTarget.props.route);
    };

    return (
        <div className="d-flex">
            <Drawer
                expanded={true}
                position={"start"}
                mode={"push"}
                mini={true}
                items={items.map((item) => ({ ...item, selected: item.route === selected }))}
                onSelect={onSelect}
                animation={false}
                item={CustomItem}
                style={{ flex: 1, minHeight: "66vh", height: "100%" }}
            >
                <DrawerContent className="mx-3">
                    {childMap[selected]({
                        module,
                        settings,
                        setSettings,
                        setChangeMade,
                        hideGrid: true,
                    })}
                </DrawerContent>
            </Drawer>
        </div>
    );
};

export default AccountSettingsRouter;
